import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { DropdownMenu } from '../modals/dropdown-menu/DropdownMenu';

type Item = {
  onSelect: (event: Event) => void;
  title: ReactNode;
  icon?: ReactNode;
  type?: 'danger' | 'warning';
  disabled?: boolean;
  tooltipText?: string;
};

type AddBlockButtonProps = {
  id?: string;
  text: string;
  items: Item[];
  onClick?: () => void;
  icon?: ReactNode;
};

export const SplitButton: React.FC<AddBlockButtonProps> = ({ id, text, icon, items }) => (
  <DropdownMenu
    items={items}
    trigger={
      <ButtonContainer id={id}>
        <Button>
          {icon}
          {text}
        </Button>

        <OpenSelectButton>
          <ChevronDownIcon />
        </OpenSelectButton>
      </ButtonContainer>
    }
  />
);

const Button = styled.button`
  display: flex;
  gap: 0.8rem;
  min-height: 3.2rem;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-secondary);
  border-radius: 0.5rem;
  color: white;
  cursor: pointer;
  height: 100%;
  font-weight: 500;
  font-size: 1.4rem;
  background: none;
  line-height: 1.9rem;
  padding-inline-start: 1rem;
`;

const ButtonContainer = styled.div`
  gap: 1rem;
  display: flex;
  align-items: center;
  background: var(--color-secondary);
  border-radius: 0.5rem;
  height: 3.2rem;

  path {
    fill: white;
  }
`;

const OpenSelectButton = styled.button`
  padding: 0 0.8rem;
  height: 100%;
  background: unset;
  border: unset;
  cursor: pointer;
  border-left: 0.1rem solid #2053b6;

  svg {
    height: 1.6rem;
    width: 1.6rem;
  }
`;
